import React from "react";
import PropTypes from "prop-types";
import ErrorBox from "./ErrorBox";
import SpaLevelErrorDisplay from "./SpaLevelErrorDisplay";

/**
 * Error boundary that catches JavaScript errors in child component tree.
 * @param {Object} props
 * @param {boolean} [props.spaLevel=false] - When true, displays a full-page style error with icon, explanation text and error box. Use for app/route-level boundaries.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { spaLevel } = this.props;

      if (spaLevel) {
        return <SpaLevelErrorDisplay error={this.state.error} />;
      }

      return <ErrorBox error={this.state.error} />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  spaLevel: PropTypes.bool,
};

export default ErrorBoundary;
